//
// SWITCHER
//
export const handleRadioSwitcherInit = (switcher) => {
  const inputChecked = switcher.querySelector('input:checked');

  // Caret
  const label = inputChecked.parentElement;
  const labelWidth = label.offsetWidth;
  const labelLeft = label.offsetLeft;

  const caret = switcher.querySelector('.js-radio-switcher-caret');

  caret.style.left = `${labelLeft}px`;
  caret.style.width = `${labelWidth}px`;

  // Focus
  inputChecked.addEventListener('change', () => {
    const closestRow = switcher.closest('.form__row');
    const nextRow = closestRow?.nextSibling.nextSibling;
    const formEl = nextRow?.querySelector('input, textarea');

    if (formEl) {
      setTimeout(() => {
        formEl.focus();
      }, 0);
    }
  });
};

const radioSwitchers = document.querySelectorAll('.js-radio-switcher');

radioSwitchers.forEach((switcher) => {
  const handler = handleRadioSwitcherInit.bind(null, switcher);

  // On document ready
  document.addEventListener('DOMContentLoaded', handler);

  // On window resize
  window.addEventListener('resize', handler);
});

document.addEventListener('click', (e) => {
  const switcherSelector = e.target.closest('.js-radio-switcher');

  if (switcherSelector) {
    handleRadioSwitcherInit(switcherSelector);
  }
});
